import React from 'react';
import { LayoutContext } from 'contexts';
import { useParams } from 'react-router-dom';
import MyBrokerageContext from './MyBrokerageContext';
import { StyledPagination } from './StyledComponents';

type TableFooterProps = {
  height: number;
};

const pageSize = 20;

const TableFooter: React.FC<TableFooterProps> = ({ height }) => {
  const { pageNumber } = useParams<{ pageNumber: string }>();
  const { getSiderCurrentWidth, transition } = React.useContext(LayoutContext);
  const {
    results: { count },
    queryData,
    setQueryData,
  } = React.useContext(MyBrokerageContext);

  const handlePageChange = (page: number) => {
    setQueryData(prev => ({ ...prev, pageNumber: page - 1 }));
  };

  if (queryData.type === 'openHouses') return null;
  if (!count || count <= pageSize) return null;

  return (
    <StyledPagination
      current={Number(pageNumber) + 1}
      onChange={handlePageChange}
      total={count}
      pageSize={pageSize}
      showSizeChanger={false}
      responsive
      $left={getSiderCurrentWidth()}
      $height={height}
      $transition={transition}
    />
  );
};

export default TableFooter;
